import { render } from "./App.vue?vue&type=template&id=f1a1f1ec"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=f1a1f1ec&lang=scss"

import exportComponent from "E:\\code\\test\\clink_home-master\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__